import React, { Component } from 'react';

import PropTypes from 'prop-types';

import CapterraPixel from 'common/ads/CapterraPixel';
import AJAX from 'common/AJAX';
import { TrackEventContext } from 'common/containers/EventContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import Button from 'common/inputs/Button';
import SubdomainInput from 'common/inputs/SubdomainInput';
import TextInput from 'common/inputs/TextInput';
import Strings from 'common/Strings';
import UserAvatar from 'common/user/UserAvatar';
import getCookies from 'common/util/getCookies';
import parseJSON from 'common/util/parseJSON';
import withContexts from 'common/util/withContexts';
import validateInput from 'common/validateInput';

import 'css/components/company/_CreateCompanyForm.scss';

class CreateCompanyForm extends Component {
  static propTypes = {
    onSuccess: PropTypes.func,
    trackEvent: PropTypes.func,
    trialPlan: PropTypes.oneOf(['starter', 'growth', 'core', 'pro']),
    viewer: PropTypes.shape({
      email: PropTypes.string,
      name: PropTypes.string,
    }),
  };

  state = {
    companyName: '',
    error: null,
    qualified: null,
    submitting: false,
    success: false,
    vip: null,
  };

  constructor(props, context) {
    super(props, context);

    this.companyRef = React.createRef();
    this.subdomainRef = React.createRef();
  }

  onCompanyNameChange = (e) => {
    this.setState({
      companyName: e.target.value,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (this.state.submitting) {
      return;
    }

    const { trackEvent, trialPlan } = this.props;
    trackEvent('Submitted Register Form');

    const companyName = this.companyRef.current.getValue().trim();
    const subdomain = this.subdomainRef.current.getValue().trim();

    var error = null;
    if (!companyName || !validateInput.companyName(companyName)) {
      error = 'Please enter a valid company name.';
    } else if (!subdomain || !validateInput.subdomain(subdomain)) {
      error = 'Please enter a valid subdomain.';
    }

    if (error) {
      this.setState({ error });
      return;
    }

    trackEvent('Completed Registration');
    trackEvent('Made Register Request');

    this.setState({
      error: null,
      submitting: true,
    });

    const [hubspotutk] = getCookies(['hubspotutk']);
    this._subdomain = subdomain;
    AJAX.post(
      '/api/company/create',
      {
        companyName,
        hubspotutk,
        subdomain,
        trialPlan,
      },
      this.onSubmitResponse
    );
  };

  onSubmitResponse = (responseJSON) => {
    parseJSON(responseJSON, (error, responseObject) => {
      if (error) {
        this.setState({
          error: Strings.miscError,
        });
        return;
      }

      const { trackEvent } = this.props;

      if (responseObject.success) {
        trackEvent('Registered Company');

        window.qp?.('track', 'CompleteRegistration');

        if (responseObject.isVIP) {
          trackEvent('Registered VIP Company');
        }

        if (responseObject.qualified) {
          trackEvent('Registered Qualified Company');
        }

        this.setState({
          success: true,
          qualified: responseObject.qualified,
          vip: responseObject.isVIP,
        });

        // so event can send
        setTimeout(() => {
          const subdomain = this._subdomain;
          this.props.onSuccess({ subdomain });
        }, 400);
        return;
      }

      const { error: responseError } = responseObject;

      trackEvent('Failed to Register', {
        error: responseError,
      });

      const errorMessage =
        {
          'email domain is not trusted':
            'The email linked to your user is not allowed to create a new company. Please, change your email to continue.',
          'subdomain taken':
            'Sorry, this subdomain is already in use by someone else. Try something else.',
          'slow down':
            'You are trying to create too many accounts. Please wait a few minutes before trying again.',
        }[responseError] || Strings.miscError;

      this.setState({
        submitting: false,
        error: errorMessage,
      });
    });
  };

  renderError() {
    if (!this.state.error) {
      return null;
    }

    return <div className="error">{this.state.error}</div>;
  }

  renderPixel() {
    const { success, qualified, vip } = this.state;
    if (!success) {
      return null;
    }

    if (!qualified && !vip) {
      return null;
    }

    return <CapterraPixel />;
  }

  renderViewer() {
    const { viewer } = this.props;
    return (
      <div className="viewer">
        <UserAvatar loading="eager" user={viewer} />
        <div className="name">{viewer.name}</div>
      </div>
    );
  }

  render() {
    const { submitting } = this.state;
    return (
      <form className="createCompanyForm" onSubmit={this.onSubmit}>
        {this.renderViewer()}
        <TextInput
          autoFocus={true}
          disabled={submitting}
          name="company name"
          onChange={this.onCompanyNameChange}
          placeholder="Company/App Name"
          ref={this.companyRef}
        />
        <SubdomainInput
          disabled={submitting}
          input={this.state.companyName}
          placeholder="Subdomain"
          ref={this.subdomainRef}
        />
        {this.renderError()}
        {this.renderPixel()}
        <Button
          buttonType="greenButton"
          className="submitButton"
          formButton={true}
          loading={submitting}
          type="submit"
          value="Create Company"
        />
      </form>
    );
  }
}

export default withContexts({
  trackEvent: TrackEventContext,
  viewer: ViewerContext,
})(CreateCompanyForm);
